import {create} from 'zustand';
import {nanoid} from 'nanoid';

/**
 * Store of chat messages keyed by chatId.
 * Each message shape: { id, chatId, text, createdAt, pending?, error? }
 */
const useChatMessagesStore = create((set, get) => ({
    messagesByChat: {},

    getMessages: (chatId) => get().messagesByChat[chatId] || [],

    addMessage: (chatId, message) => set((state) => {
        const existing = state.messagesByChat[chatId] || [];
        return {
            messagesByChat: {
                ...state.messagesByChat,
                [chatId]: [...existing, message],
            }
        };
    }),

    upsertMessage: (chatId, message) => set((state) => {
        const list = state.messagesByChat[chatId] || [];
        const index = list.findIndex(m => m.id === message.id);
        let newList;
        if (index === -1) {
            newList = [...list, message];
        } else {
            newList = list.slice();
            newList[index] = {...list[index], ...message};
        }
        return {
            messagesByChat: {
                ...state.messagesByChat,
                [chatId]: newList,
            }
        };
    }),

    replaceMessages: (chatId, messages) => set((state) => ({
        messagesByChat: {
            ...state.messagesByChat,
            [chatId]: messages,
        }
    })),

    resetChat: (chatId) => set((state) => {
        const copy = {...state.messagesByChat};
        delete copy[chatId];
        return {messagesByChat: copy};
    }),

    resetAll: () => set({messagesByChat: {}}),

    // Helper to build a message object
    buildMessage: ({chatId, text}) => ({
        id: nanoid(),
        chatId,
        text,
        createdAt: new Date().toISOString(),
    }),
}));

export default useChatMessagesStore;

